export const getButtonGroupButtonVariant = isSelected => (isSelected ? 'primary' : 'outline-secondary')
